import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { CustomChartPoint } from '@/entities/dashboards';
import { fmt } from '../../utils';

/** Наведённый элемент диаграммы: recharts кладёт исходную точку данных в `payload`. */
type TooltipItem = {
  payload?: CustomChartPoint;
};

type Props = {
  /** Курсор на диаграмме: без наведения recharts зовёт содержимое подсказки с `false` */
  active?: boolean;
  payload?: readonly TooltipItem[];
};

/**
 * Подсказка точки линейной и столбца столбчатой диаграммы: подпись и величина.
 *
 * Своё содержимое, а не готовое от recharts: у готового цвета заданы значениями и в тёмной теме
 * подсказка осталась бы светлой.
 */
export const ChartPointTooltip: FC<Props> = ({ active, payload }) => {
  const { t } = useTranslation('qualityDashboard');

  const point = payload?.[0]?.payload;
  if (!active || !point) return null;

  return (
    <div className="rounded-md border bg-popover px-3 py-2 text-xs text-popover-foreground shadow">
      {t('presets.chart.pointTooltip', { label: point.label, value: fmt(point.value) })}
    </div>
  );
};
